exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".add-extra-alert-meta{flex:0 0 auto;margin-bottom:8px}.add-extra-alert-helper{margin:0 0 8px;font-weight:400}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./Client/app/views/account.management/add.extra.alert.component.css
// module id = 1120
// module chunks = 0